import React from 'react';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { GlobalViewTaxForm } from './global-viewtaxform';
import { ViewTaxFormPropTypes } from '../../shapes';

export const BWTaxViewTaxForm = props => (
  <GlobalViewTaxForm
    {...props}
    countryCode={Constants.CountryCode.BW}
    showTaxCert={false}
  />
);

BWTaxViewTaxForm.propTypes = ViewTaxFormPropTypes;
